// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Vo-z","imageAndVideoCount":"Wo-z","imageAndVideoContainer":"Xo-z","viewAllReviews":"Yo-z"};